export default __webpack_public_path__ + "static/media/hand.35f72755.svg";